import React, { Component } from 'react';

import './styles.less';

const RadioButton = ({ label, selected, value, onSelection }) => (
  <div
    className="radio-button-container"
    data-val={value}
    onClick={onSelection}
  >
    <div
      data-val={value}
      className={`radio-button-check${selected ? ' radio-selected' : ''}`}
    >
      <div data-val={value} className="radio-button-check-center" />
    </div>
    <span data-val={value} className="radio-label">
      {label}
    </span>
  </div>
);

class RadioGroup extends Component {
  onSelectRadioButton = ev => {
    this.props.onSelection(ev.target.dataset.val);
  };

  render() {
    const { selectedValue, options, groupClass } = this.props;

    return (
      <div className={groupClass}>
        {options.map(({ label, value }) => (
          <RadioButton
            label={label}
            value={value}
            key={value}
            onSelection={this.onSelectRadioButton}
            selected={value === selectedValue ? true : false}
          />
        ))}
      </div>
    );
  }
}

export default RadioGroup;
